import React, { useMemo, useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getRegion, deleteRegion  } from "service/api";
// import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";



function DatatableTables() {
    const[alluserlist,setallusers] = useState({ users: [] });
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

    const navigate = useNavigate();

    useEffect(()  => {
        getallusers();
    }, []);

    const getallusers = async () => {
        let response = await getRegion();
        if (response.error) {
            console.log('Error while fetching data:', response.error);      
        } else {
            setallusers({users: response.data});
            //console.log(response.data);
        }
    }

    const openDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setSelectedDeleteId(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    try {
      await deleteRegion(selectedDeleteId);
      toast.success("Region deleted successfully");
      getallusers();
    } catch (error) {
      toast.error("Failed to delete region");
      console.error("Delete error:", error);
    } finally {
      closeDeleteModal();
    }
  };


    const columns = useMemo(
        () => [
            {
                Header: 'Region',
                accessor: 'region',
            },

            {
                Header: "Action",
                 Cell: ({ row }) => {
                  const id = row.original._id; 
                  return (
                    <>
                     <button className="btn btn-primary mx-2"
                onClick={() => navigate(`/edit_region/${id}`)}
              >
                <i className="mdi mdi-pencil font-size-15"></i>
              </button>
                      <button className="btn btn-danger mx-2"
                    onClick={() => openDeleteModal(id)}
                    > <i className="mdi mdi-trash-can font-size-15"></i> </button>
                    </>
                  )
                },
              },
        ],
        []
    );
    //meta title
    document.title = "Region | List";

    return (
        <div className="page-content">
            <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4">
             <h1 className="page-title"></h1>
             <Link to="/add_region" className="btn btn-primary">ADD NEW REGION</Link>
            </div>
                <Breadcrumbs title="Setting" breadcrumbItem="Region" />
                <TableContainer
                        columns={columns}
                        data={alluserlist.users}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        customPageSize={10}
                        className="custom-header-css"
                />
        {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
        <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal} centered>
          <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this region?
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={confirmDelete}>Yes, Delete</Button>
            <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
            </div>
        </div>
    );
}

export default DatatableTables;